<template>
  <div class="notify">
    <transition name="slide-bottom">
      <div class="notify__inner" v-if="show" :class="this.options.type === 'error' ? 'notify__inner--error' : ''">
        <div class="notify__close" :class="this.options.type === 'error' ? 'notify__close--error' : ''">
          <a href="#" @click.prevent="hide()" class="d-block">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="notify__text">{{ options.message }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  name: 'notify',

  mixins: [setClassModifiers],

  data () {
    return {
      options: {
        message: null,
        type: null
      },
      show: false
    }
  },

  methods: {
    hide () {
      this.show = false
      this.options = {
        message: null,
        type: null
      }
    },

    showNotify (e) {
      const options = e.detail
      setTimeout(() => {
        this.options = options
        this.show = true
        setTimeout(() => {
          this.hide()
        }, options.timeout)
      }, options.delay)
    }
  },

  mounted () {
    window.addEventListener('notify', this.showNotify)
  }
}
</script>

<style lang="scss">
  .notify {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: $elevation;
    z-index: 999999;
    width: 100%;

    @include respond(tab-port) {
      bottom: 1.7rem;
      width: initial;
    }

    &__inner {
      background: $color-success;
      padding: .9rem 1.5rem;

      &--error {
        background-color: $color-error;
      }

      //display: flex;
      //align-items: center;

      @include respond(tab-port) {
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
      }

      color: $color-white;
      font-size: 1.4rem;
      white-space: pre-wrap;
      width: 100%;
      text-align: center;
      justify-content: center;

      @include respond(tab-port) {
        border-radius: $border-radius;
        width: initial;
        justify-content: initial;
      }
    }

    &__text {
      @include respond(tab-port) {
        margin-right: 1rem;
      }
    }
    &__close {
      //top: -2.5rem;
      //left: 50%;
      //transform: translateX(-50%);
      //display: none;
      position: relative;
      padding-bottom: .5rem;

      color: $color-white;

      & > * {
        color: $color-white;
      }

      @include respond(tab-port) {
        color: $color-white;
        display: block;
        padding-top: .1rem;
        padding-bottom: 0;
      }
    }

    &__close-icon {
      font-size: 3rem;

      @include respond(tab-port) {
        font-size: 1.2rem;
      }
    }
  }
</style>
